import React, { useState } from "react";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainContent from "./pages/MainBody";



function AppWrapper() {
  // Use mock data directly, no loading/error states needed
  return (
    <Router>
      <Box sx={{ 
        display: "flex", 
        flexDirection: "column", 
        minHeight: "100vh",
        backgroundColor: "#f9f9f9"
      }}>
        <Routes>
          <Route path="/" element={
            <MainContent 
           
          
            />
          } />
        </Routes>
      </Box>
    </Router>
  );
}

export default AppWrapper;